import { BsThreeDots } from 'react-icons/bs';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import '../styles/ScoreCards.css';

const CardMenu = ({ isOpen, onToggle, onRename, onDelete, scoreId }) => {
  return (
    <div className="card-menu-button" onClick={(e) => e.stopPropagation()}>
      <div onClick={onToggle}>
        <BsThreeDots />
      </div>
      {isOpen && (
        <div className="card-dropdown-menu">
          <div className="card-dropdown-item" onClick={(e) => { e.stopPropagation(); onRename?.(e); }}>
            <FiEdit2 style={{ marginRight: '8px' }} />
            Rename
          </div>
          <div className="card-dropdown-item delete" onClick={(e) => { e.stopPropagation(); onDelete?.(e); }}>
            <FiTrash2 style={{ marginRight: '8px' }} />
            Delete
          </div>
        </div>
      )}
    </div>
  );
};

export default CardMenu;
